export const toHectare = (unit: string, value: number): number => {
    if(unit === 'ha' || unit === 'hectare') {
        return value;
    }
    const conversionRates: { [key: string]: number } = {
        sqm: 0.0001,
        sqft: 0.0000092903,
        acre: 0.404686
    };

    return Math.round(value * (conversionRates[unit] || 1) * 100) / 100;
}

export const toSquareMeter = (unit: string, value: number): number => {
    if(unit === 'sqm' || unit === 'square meter') {
        return value;
    }
    const conversionRates: { [key: string]: number } = {
        hectare: 10000,
        sqft: 0.092903,
        acre: 4046.86
    };

    return Math.round(value * (conversionRates[unit] || 1) * 100) / 100;
}

export const convertUnit = (unit: string, value: number, targetUnit: string): number => {
    if(unit === targetUnit) {
        return value;
    }

    if(targetUnit === 'sqm') {
        return toSquareMeter(unit, value);
    } else if(targetUnit === 'ha' || targetUnit === 'hectare') {
        return toHectare(unit, value);
    } else {
        return value; // If target unit is not recognized, return the original value
    }
}